import { render, staticRenderFns } from "./SyncSessionList.vue?vue&type=template&id=8ef9848c&scoped=true"
import script from "./SyncSessionList.vue?vue&type=script&lang=js"
export * from "./SyncSessionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef9848c",
  null
  
)

export default component.exports